import React from 'react';

export default function CharacteristicList(props) {
    return (
        <div className="characteristic-list">
            {
                props.characteristics.map((characteristic) => 
                    <div key={characteristic} className="characteristic-list-item">
                        <p className="black-header-6-text">{characteristic}</p>
                    </div>
                )
            }
        </div>
    );
}